<div class="rotating-border-card">
  <div class="card-overlay"></div>
  <ng-content></ng-content>
</div>
